import _defineProperty from "babel-runtime/helpers/defineProperty";

import defineCfg from "./defineConfig";

var txtConfig = _defineProperty({}, defineCfg.$definecfg.QSJGDM_CONST.GUOTOU, {
  "welcomeUse": "欢迎您使用国投证券智能柜员机",
  "likeToDo": "我自愿在国投证券办理",
  "v0020BizInfo": "公司的上交所期权考试成绩单及模拟交易清单（如在国投证券任一营业部参加考试或模拟交易，请联系您的客户经理提供。如在其他期权经营机构考试，请联系该机构提供。",
  "qsName": "国投证券"
});

var plugin = {
  install: function install(Vue) {
    Vue.txtcfg = txtConfig;

    Vue.prototype.$txtcfg = txtConfig;
  },

  $txtcfg: txtConfig
};

export default plugin;
export var install = plugin.install;


//////////////////
// WEBPACK FOOTER
// ./src/config/txtConfig.js
// module id = 400
// module chunks = 2